import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import '../../assets/css/admin/allcourses.css';

const AllBankStdLoans = () => {
    const [bankStdLoan, setbankStdLoan] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredBankStdLoans, setFilteredBankStdLoans] = useState([]);

    useEffect(() => {
        fetchbankStdLoan();
    }, []);

    const fetchbankStdLoan = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/bankStdLoan/all');
            const data = await response.json();
            setbankStdLoan(data);
            setFilteredBankStdLoans(data); // Initialize filtered data
        } catch (error) {
            console.error('Error fetching Student Loans:', error);
        }
    };

    // Real-time filtering effect
    useEffect(() => {
        if (!searchTerm.trim()) {
            // If search is empty, show all bank student loans
            setFilteredBankStdLoans(bankStdLoan);
            return;
        }
        
        // Filter bank student loans based on multiple fields
        const filtered = bankStdLoan.filter(loan => 
            (loan.bankName && loan.bankName.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (loan.stdLoanName && loan.stdLoanName.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (loan.phone && loan.phone.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (loan.email && loan.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (loan.location && loan.location.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        
        setFilteredBankStdLoans(filtered);
    }, [searchTerm, bankStdLoan]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleDelete = async (bankStdLoanId) => {
        try {
            const response = await fetch(`https://api.myskills.lk/bankStdLoan/delete/${bankStdLoanId}`, {
                method: 'POST'
            });
            if (response.ok) {
                const updatedLoans = bankStdLoan.filter(loan => loan.id !== bankStdLoanId);
                setbankStdLoan(updatedLoans);
                // Also update filtered loans
                setFilteredBankStdLoans(updatedLoans.filter(loan => 
                    !searchTerm || 
                    (loan.bankName && loan.bankName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    (loan.stdLoanName && loan.stdLoanName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    (loan.phone && loan.phone.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    (loan.email && loan.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    (loan.location && loan.location.toLowerCase().includes(searchTerm.toLowerCase()))
                ));
            } else {
                console.error('Failed to delete Student Loan');
            }
        } catch (error) {
            console.error('Error deleting Student Loan:', error);
        }
    };

    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL BANK STUDENT LOANS</h1>
                    <form>
                        <input 
                            type="text" 
                            value={searchTerm}
                            onChange={handleSearch}
                            placeholder='Search Item' 
                        />
                        <input type="submit" value="SEARCH" onClick={(e) => e.preventDefault()} />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table> 
                            <thead>
                                <tr>
                                <th>Bank Name</th>
                                    <th>Student Loan Name </th>
                                    {/* <th>University Name</th> */}
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>Location</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredBankStdLoans.length > 0 ? (
                                filteredBankStdLoans.map((bankStdLoan) => (
                                    <tr key={bankStdLoan.id}>
                                        <td>{bankStdLoan.bankName}</td>
                                        <td>{bankStdLoan.stdLoanName}</td>
                                        {/* <td>{bankStdLoan.university}</td> */}
                                        <td>{bankStdLoan.phone}</td>
                                        <td>{bankStdLoan.email}</td>
                                        <td>{bankStdLoan.location}</td>
                                        <td>
                                            {bankStdLoan.website ? (
                                                <a href={bankStdLoan.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                            ) : (
                                                <span style={{ color: '#999' }}>No Website</span>
                                            )}
                                        </td>
                                        <td id='action-buttons'>
                                            {/* <a href="#!" id='man-details' onClick={() => handleEdit(course.id)}>EDIT</a> */}
                                            <a href="#!" id='del-details' onClick={() => handleDelete(bankStdLoan.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{textAlign: 'center'}}>No bank student loans found matching your search</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllBankStdLoans;
